The candidate process history to create.
